var _excluded = ["property"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { getImageUrl, AllImageSizes, PropertyType } from '@domain-group/fe-allhomes-library';
import { AllhomesListingCard } from './allhomes-listing-card';
import { ListingCardFragmentDoc } from './allhomes-listing-card.fragment.generated';
import { jsx as ___EmotionJSX } from "@emotion/core";
var fragment = ListingCardFragmentDoc;
export var mapGQLProps = _ref => {
  var _address$cadastralPar, _agencies$;
  var listing = _ref.listing,
    address = _ref.address,
    features = _ref.features,
    agencies = _ref.agencies;
  return {
    id: listing.id,
    url: listing.url,
    title: listing.title,
    images: {
      listingImage: listing.firstImage && getImageUrl(listing.firstImage.imageSrc, AllImageSizes.PHONE_LARGE),
      listingImageLowResolution: listing.firstImage && getImageUrl(listing.firstImage.imageSrc, AllImageSizes.SMALL)
    },
    price: listing.price,
    address: {
      street: address.line1,
      suburb: address.division.name,
      state: address.state.abbrev,
      postcode: address.postcode
    },
    features: {
      beds: features.bedrooms,
      baths: features.bathrooms.bathrooms,
      ensuite: features.bathrooms.ensuites,
      garage: features.parking.garages,
      carport: features.parking.carports,
      parking: features.parking.other,
      propertyType: features.propertyType,
      landSize: (_address$cadastralPar = address.cadastralParcel) === null || _address$cadastralPar === void 0 ? void 0 : _address$cadastralPar.blockSize
    },
    listingBadges: {
      annotations: listing.annotations
    },
    propertyType: PropertyType[features.propertyType].label,
    agencyName: (_agencies$ = agencies[0]) === null || _agencies$ === void 0 ? void 0 : _agencies$.name
  };
};
export var AllhomesListingCardGraphQL = _ref2 => {
  var property = _ref2.property,
    props = _objectWithoutProperties(_ref2, _excluded);
  return ___EmotionJSX(AllhomesListingCard, _extends({}, mapGQLProps(property), props));
};
AllhomesListingCardGraphQL.fragment = fragment;